import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import styles from './Fusion.module.scss';

import IconFusionMobileAssets from '../../assets/imgs/fusion/fusion_mobile_assets_new.png';
import IconFusionNFT from '../../assets/imgs/fusion/fusion_nft_new.png';
import { GameAssetsPage } from '../../components/FusionComponents/GameAssetsPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
// import QuestionMarkIcon from '../../assets/icons/icon-question-mark.png';
import { Login } from '../../components';
import { useTranslation } from 'react-i18next';
import { middleEllipsis } from '../../helpers/middleEllipsis';
import { useCookies } from 'react-cookie';
import { useContext } from 'react';
import { IpContext, TokenContext, TYPES } from '../../components/Context';
import firebase from "firebase";
import { FusionOrderHistoryPage } from '../../components/FusionComponents/FusionOrderHistoryPage/FusionOrderHistoryPage';
import { Web3Context } from '../../web3';
import metamaskLogo from '../../assets/imgs/icon-metamask.png';
import coinbaseLogo from '../../assets/imgs/home/icon-coinbase.png';
import personLogo from '../../assets/imgs/bind/icon-person.png';
import personLogoWhite from '../../assets/icons/icon-person-white.png';


const Fusion = () => {
    const [t] = useTranslation();
    const location = useLocation();
    const currentPath = location.pathname.split("/")[2];
    const [showLoginModal, setShowLoginModal] = useState(false);

    // Todo: Check and update from Context for login status everywhere.
    const [loggedIn, setLoggedIn] = useState(false);
    const [userDetails, setUserDetails] = useState({});
    const [walletInfo, setWalletInfo] = useState({});
    const [siwaCookies, removeSiwaCookies] = useCookies(['SiwaAuthId']);
    const [, tokenDispatch] = useContext(TokenContext);
    const { isInChina } = useContext(IpContext);
    const { provider } = useContext(Web3Context);


    const Categories = [
        {
            name: 'Tracking (Mobile Asset)',
            image: IconFusionMobileAssets,
            location: 'game-assets'
        },
        {
            name: 'Fusion (NFT)',
            image: IconFusionNFT,
            location: 'nft'
        },
    ];

    useEffect(() => {
        const loggedInPages = JSON.parse(localStorage.getItem('showLoginOnLoad'));
        if (loggedInPages?.fusionPage) {
            setShowLoginModal(true);
        }
    }, [])

    useEffect(() => {
        if (loggedIn && userDetails && walletInfo) {
            const loggedInPages = JSON.parse(localStorage.getItem('showLoginOnLoad'));
            let updatedLoggedInPages = loggedInPages || {};
            Object.keys(updatedLoggedInPages).forEach((pages) => {
                updatedLoggedInPages[pages] = true;
            });
            updatedLoggedInPages['fusionPage'] = true;
            localStorage.setItem('showLoginOnLoad', JSON.stringify(updatedLoggedInPages));
        };
    },[userDetails, walletInfo, loggedIn])

    const defaultContainer = () => (
        <>
            <div className={styles.fusion_system_categories}>
                {Categories.map((category, index) => (
                    <Link to={`/fusion/${category.location}`}
                        key={index}
                        className={`${styles.category} ${currentPath === category.location && styles.selected_category}`}
                    >
                        <img src={category.image} alt={category.name} />
                        <span className={styles.category_name}>{category.name}</span>
                    </Link>
                ))}
            </div>

            <div className={styles.fusion_system_contents}>
                <Switch>
                    <Route exact path='/fusion/game-assets' render={() => <GameAssetsPage setShowLoginModal={setShowLoginModal} loggedIn={loggedIn} walletInfo={walletInfo} FusionType={"in-game"} />} />
                    <Route exact path='/fusion/nft' render={() => <GameAssetsPage setShowLoginModal={setShowLoginModal} loggedIn={loggedIn} walletInfo={walletInfo} FusionType={"blockchain"} />} />
                </Switch>
            </div>
        </>
    );

    const handleSignOut = () => {
        if (siwaCookies.SiwaAuthId != null) {
            removeSiwaCookies('SiwaAuthId', { path: '/' });
        }
        if (!isInChina) {
            firebase.auth().signOut();
        }

        const loggedInPages = JSON.parse(localStorage.getItem('showLoginOnLoad'));
        let updatedLoggedInPages = loggedInPages || {};
        Object.keys(updatedLoggedInPages).forEach((pages) => {
            updatedLoggedInPages[pages] = false;
        });
        localStorage.setItem('showLoginOnLoad', JSON.stringify(updatedLoggedInPages));

        setUserDetails({});
        setWalletInfo({});
        setLoggedIn(false);
        tokenDispatch({
            type: TYPES.SET_USER_ID,
            payload: "",
        });
    }

    return (
        <div className={styles.fusion_system_container}>
            <div className={styles.fusion_system}>
                <div className={styles.fusion_system_header}>
                    <div className={styles.title_and_description}>
                        <div className={styles.title}>
                            <span>Unknown Device</span>
                            {/* <img src={QuestionMarkIcon} alt="help" /> */}
                        </div>
                        <div className={styles.description}>
                            <p>An unknown device disguised as a shooting star fell from the sky. Two heroes, Valorious and Centurion handed it over to you to research and understand its capabilities.</p>
                            <p>For now you can <b>Track</b> and <b>Fuse</b>. Consequences remain unknown, use at your own risk!</p>
                        </div>
                    </div>

                    <div className={styles.user_details_container}>
                        {loggedIn ?
                            <div className={styles.user_details}>
                                <div className={styles.detail_field}>
                                    <img src={personLogo} alt="user" />
                                    <span>{userDetails.cdhUserId}</span>
                                    <div onClick={handleSignOut} style={{ cursor: "pointer", marginLeft: "8px" }}><FontAwesomeIcon icon={faSignOutAlt}/></div>
                                </div>

                                {walletInfo?.WalletIdChecksumed &&
                                    <div className={styles.detail_field}>
                                        <img src={(provider?.isCoinbaseWallet || provider?.isCoinbaseBrowser) ? coinbaseLogo : metamaskLogo} alt="wallet" />
                                        <span>{middleEllipsis(walletInfo.WalletIdChecksumed)}</span>
                                    </div>
                                }
                                <Link to="/fusion/order-history" className={styles.order_history_btn}>Order History</Link>
                            </div> :
                            <button onClick={() => setShowLoginModal(true)} className={styles.login_btn}>
                                <img src={personLogoWhite} alt="user" />
                                <span>Connect Game ID</span>
                            </button>
                        }
                    </div>
                </div>

                <div className={styles.fusion_system_body}>
                    {showLoginModal &&
                        <Login
                            title={t('Login to Fusion')}
                            descriptions={t('Please login your CDH User ID to complete your action.')}
                            loginCharacterImage={''}
                            setShow={setShowLoginModal}
                            setLoggedIn={setLoggedIn}
                            setUserDetails={setUserDetails}
                            setWalletInfo={setWalletInfo}
                        />
                    }
                    <Switch>
                        <Route exact path='/fusion/'><Redirect to='/fusion/game-assets' /></Route>
                        <Route exact path='/fusion/order-history' render={() => <FusionOrderHistoryPage setShowLoginModal={setShowLoginModal} loggedIn={loggedIn} walletInfo={walletInfo} />} />

                        <Route render={defaultContainer} />
                    </Switch>
                </div>
            </div>
        </div>
    )
}

export { Fusion };
